import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router';

import Conversations from '@/components/pages/Conversations/Conversations';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';
import Conversation from '@/modules/humanChat/components/Conversation/Conversation';
import { SubNavConversationNew } from '@/modules/humanChat/components/SubNavConversation';
import { resetView } from '@/modules/humanChat/redux/actions';

import NotFound from '../NotFound/NotFound';

const ConversationsRouter: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetView());
    };
  }, [dispatch]);

  return (
    <div className="flex h-full w-full">
      <SubNavConversationNew />
      <PermissionsWrapper module="conversations">
        <Routes>
          <Route path="/" element={<Navigate to="conversations" replace />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/conversations/:sessionId" element={<Conversation />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PermissionsWrapper>
    </div>
  );
};

export default ConversationsRouter;
